import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatIsGri = () => {
  const urlConfig = {
    name: "Gri.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/GRIStandards.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="GRI"
            title={"GRI Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for Environmental <br />
            sustainability.
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What is GRI? — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
              }}
            >
              The Global Reporting Initiative (GRI) is an independent,
              international organization that sets the world’s leading standards
              for sustainability reporting. Its comprehensive framework enables
              organizations to systematically disclose their environmental,
              social and governance (ESG) impacts in a transparent, consistent,
              and comparable manner. The GRI Standards are globally recognized
              as the benchmark for corporate sustainability reporting, fostering
              accountability and driving sustainable development across all
              sectors.
            </Typography>
          </Box>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
              mb: 2,
            }}
          >
            GRI ensures that reporting goes beyond showcasing achievements,
            requiring organizations to disclose material impacts both positive
            and negative — on the economy, environment, and society. This
            holistic approach supports informed decision-making by stakeholders,
            including investors, regulators, civil society, and business
            partners, and helps organizations identify and manage ESG risks and
            opportunities effectively.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
            }}
          >
            Highly relevant in today’s global landscape, GRI aligns with major
            international frameworks such as the UN Sustainable Development
            Goals (SDGs), reinforcing corporate responsibility and sustainable
            value creation. Its principles — such as stakeholder inclusiveness,
            sustainability context, materiality, and completeness — ensure that
            reports are meaningful, credible, and actionable.
          </Typography>
        </Box>
        {/* <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <CustomButton
            title="Access Full GRI Standards Documentation"
            route="/reporting/whatisgri"
          />
        </Box> */}
        <Box>
          <Box>
            <DownloadZipButton
              config={urlConfig}
              title="Access Full GRI Standards Documentation"
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatIsGri;
